import { getNode, getPosts } from '@space-cow-media/wp-components'

import ArticlePage from '@/components/Wordpress/ArticlePage/ArticlePage'
import { ARTICLES_REVALIDATE_INTERVAL } from '@/utils/constants'

export const getStaticPaths = async () => {
  try {
    const { posts } = await getPosts({ categoryId: 4, pageSize: 10 })
    const paths = posts.map(({ slug }) => ({ params: { slug } }))
    return {
      paths,
      fallback: 'blocking',
    }
  } catch (e) {
    console.error(e)
    return { paths: [], fallback: 'blocking' }
  }
}

export const getStaticProps = async ({ params: { slug } }: { params: { slug: string } }) => {
  const revalidateInterval = slug === 'test-post' ? 5 : ARTICLES_REVALIDATE_INTERVAL

  const post = await getNode(slug as string)
  if (post === null) return { notFound: true }

  return {
    props: { enableAdhesion: true, post },
    revalidate: revalidateInterval,
  }
}

export default ArticlePage
